import {
    css, Theme,
} from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        form: css`
        ${custom.stepElementPadding};
        padding-right: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    `,
        checkbox: css`
        padding-left: 5px;
    `,
        checkboxLabel: css`
          & .MuiFormControlLabel-label {
            font-size: ${theme.typography.h3.fontSize}px;
            line-height: ${theme.typography.h3.lineHeight};
          }
    `,
    }
}

export default styles
